<template>
  <div class="home">
        <p class="h3 mb-2 pt-2 pb-4">Est-ce que vous connaissez déjà la puissance requise?</p>

        <div class="form-check check-tile  mb-3" @click="setData('known_power',false)">
          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios1" value="option1">

          <router-link tag="label" :to="{name:routerTo}" class="form-check-label" for="exampleRadios1">
            <div>
              <p class="mb-0 lead">Calculer pour moi</p>
              <span class="text-secondary">Nous calculons pour vous la puissance optimale</span>
            </div>
            <i class="fal fa-arrow-right fa-2x text-primary"></i>
          </router-link>
        </div>

        <div class="form-check check-tile" @click="setData('known_power',true)">
          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios2" value="option2">
          <router-link tag="label" :to="{name:'RoomType'}" class="form-check-label" for="exampleRadios2">
            <div>
              <p class="mb-0 lead">Je connais la puissance</p>
              <span class="text-secondary">Vous connaissez déjà la puissance nécessaire</span>
            </div>
            <i class="fal fa-arrow-right fa-2x text-primary"></i>
          </router-link>
        </div>
  </div>
</template>

<script>

export default {
  name: 'FirstChoice',
  computed:{
    routerTo(){
      if (this.state.sent&&this.state.house_type)return 'RoomType'
      else return 'HouseType'
    },
  }
}
</script>
